import { render, staticRenderFns } from "./addRepair.vue?vue&type=template&id=1c383818&scoped=true&"
import script from "./addRepair.vue?vue&type=script&lang=js&"
export * from "./addRepair.vue?vue&type=script&lang=js&"
import style0 from "./addRepair.vue?vue&type=style&index=0&id=1c383818&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c383818",
  null
  
)

export default component.exports